import React from 'react';
import ReactDOM from 'react-dom';
import FormModuleLookup from '../components/FormModuleLookup';
import FormItemStringEditor from './FormItemStringEditor';
import EditorForDataGridMix from './EditorForDataGridMix';
import LookupActions from '../actions/LookupActions';
import RecordsActions from '../actions/RecordsActions';
import UtilActions from '../actions/UtilActions';
import LookupReturnStore from '../stores/LookupReturnStore';
import {LookupDropDownCloseStore} from '../stores/LookupStores';
import {RecordFieldChangeStore,RecordNextStore,RecordPrevStore} from '../stores/RecordsStore';
import FormItemStringResolver from './resolver/FormItemStringResolver';
import FormItemConst from './FormItemConst';
import {DsAllowEditStore,UpdateDropDownContentStore} from '../stores/CmdTypeStore';
import {GlobalClickStore} from '../stores/FocusStore';

import StringUtil from '../utils/StringUtil';
import Warn from '../utils/Warn';
import GOT from '../sysauthorityforIndustrialInternet/SysAuthoritySetup/Authority/GOT';

export default class FormItemStringEditorForDataGrid extends EditorForDataGridMix(FormItemStringEditor)
{
	initStores()
	{
		if(!this.props.forLookup)
		{
			this.unsubscribeLookupReturnStore = LookupReturnStore.listen(this.onLookupReturn.bind(this));
			this.unsubscribeRecordFieldChangeStore = RecordFieldChangeStore.listen(this.onDataFieldChanged.bind(this));
			this.unsubscribeRecordNextStore = RecordNextStore.listen(this.onRecordNext.bind(this));
			this.unsubscribeRecordPrevStore = RecordPrevStore.listen(this.onRecordPrev.bind(this));
			this.unsubscribeLookupDropDownCloseStore = LookupDropDownCloseStore.listen(this.onLookupDropDownClose.bind(this));
			this.unsubscribeDsAllowEditStore = DsAllowEditStore.listen(this.onDsAllowEditStore.bind(this));

			this.unsubscribeUpdateDropDownContenStore = UpdateDropDownContentStore.listen(this.onUpdateDropDownContnent.bind(this));

			this.unsubscribeGlobalClickStore = GlobalClickStore.listen(this.onGlobalClickHandler.bind(this));
		}
		
	}

	isClickInisdeEditor(e) 
	{
		let relatedTarget = this.getRelatedTarget(e);
		return (this.inputgroup.contains(relatedTarget) || 
					(relatedTarget.className.indexOf('editing') > -1 || 
						relatedTarget.className.indexOf('react-grid-Cell') > -1));
	  }

	onGlobalClickHandler(e)
	{
		if( $(this.inputField).attr("contenteditable") == "false" && 
			!this.isClickInisdeEditor(e))
			this.props.onCommit({key: 'Enter'});
	}

	onUpdateDropDownContnent(type,control,formModuleInstanceuuId)
	{
		if(this.props.moduleInstanceId == formModuleInstanceuuId && control == this.props.xml.name)
		{
			if(type == "numKeyBoard")
			{
				this.setState({dropDownNumKeyBoard:true});
			}
			else if(type == "normal")
			{
				this.setState({dropDownNumKeyBoard:false});
			}
		}
		
	}

	onDsAllowEditStore(groupAlias)
	{
		if(this.props.groupAlias == groupAlias)
		{
			let finalValue = this.props.control.getProperty_AllowEdit_Final();

			this.doSetEnable(finalValue);	
		}
		
	}

	onLookupReturn(value,entityId,innerId)
	{
		if(this.props.formId == entityId && this.props.xml.id == innerId)
		{
			if(Array.isArray(value) == true)
			{
				value = this.doMutiFieldReturn(value);
				// UtilActions.updateDataGrid(this.props.formId,this.props.gridXml.id);
			}
			else if(typeof(value) == "object")
			{
				value = this.doMutiFieldReturn1(value);
				// UtilActions.updateDataGrid(this.props.formId,this.props.gridXml.id);
			}
			
			
			let replace = (this.props.returnLookup == "Replace");
			if(replace)
			{
				this.closeDropDown();
			
				this.onLookupReturning = true;
				$(this.inputField).val(value);
				this.inputField.focus();
				this.inputField.select();
				// UtilActions.updateDataGrid(this.props.formId,this.props.gridXml.id);
			}
			else
			{
				this.onLookupReturning = true;
				let $t = this.inputField;
				if ($t.selectionStart || $t.selectionStart == '0') 
				{
					var startPos = $t.selectionStart;
					var endPos = $t.selectionEnd;
					var scrollTop = $t.scrollTop;
					$t.value = $t.value.substring(0, startPos) + value + $t.value.substring(endPos, $t.value.length);
					this.inputField.focus();
					$t.selectionStart = startPos + value.length;
					$t.selectionEnd = startPos + value.length;
					$t.scrollTop = scrollTop;
				}
				else {
					this.inputField.value += value;
					this.inputField.focus();
				}
				this.closeDropDown();
			}
			

			this.onLookupReturning = false;
			
			return false;
		}
	}

	calculatorReturnHandler(result)
	{
		if(result && this.state.allowEdit)
		{
			$(this.inputField).val(result);
			$(this.inputField).focus();
			$(this.inputField).select();
		}
	}

	onDataFieldChanged(record,dataField,oldValue,newValue,observer)
	{
		if(observer != this && this.props.dataField == dataField && record == this.props.rowData)
		{
			this.setDisplay(newValue);
			this.updateModifiedTag();
		}
	}


	componentWillUnmount()
	{
		//super.componentWillUnmount();
		//alert("FormItemStringEditorForDataGrid 卸载");
		if(!this.props.forLookup)
		{
			this.unsubscribeLookupReturnStore();
			this.unsubscribeRecordFieldChangeStore();
			this.unsubscribeRecordNextStore();
			this.unsubscribeRecordPrevStore();
			this.unsubscribeLookupDropDownCloseStore();
			this.unsubscribeDsAllowEditStore();
			this.unsubscribeUpdateDropDownContenStore();
			this.unsubscribeGlobalClickStore();
			this.closeDropDown();
			let lookupdiv = this.lookupStates.dropdownform;
			if(lookupdiv)
			{
				ReactDOM.unmountComponentAtNode(lookupdiv.get(0));
				lookupdiv.remove();
			}
		}		
	}

	onLookupDropDownClose(formId,innerId)
	{
		if(this.props.formId == formId && this.props.xml.id == innerId)
		{
			this.closeDropDown();
		}
	}

	getValue() {

		
		/*try {
			throw new Error();
		} catch(e) {
			console.log("Print Stack: ", e.stack);
		}*/

	    let updated = {};
		var nowAllowEdit = $(this.inputField).attr("readonly")==undefined;
		if(!nowAllowEdit)
			return;
		this.justCommit = true;
		let text;
		if(this.excelEditor)
		 	text = $(this.getInputNode()).text();
		else
			text = this.getInputNode().value;
	    var _val = FormItemStringResolver.getResult(text,this.props.trim,this.props.changeCase,this.props.stringSize,this.props.regular);
		if(_val.indexOf(FormItemStringResolver.RESOLVER_FALSE_TAG) == 0)
		{
			Warn.show({text:_val.substr(FormItemStringResolver.RESOLVER_FALSE_TAG.length)});
			return updated;
		}

		updated[this.props.column.key] = _val;
		
	    if(this.props.value != updated[this.props.column.key])
	    {
	    	RecordsActions.RecordFieldChanged(this.props.rowData,this.props.column.key,this.props.value,updated[this.props.column.key],this);
	    	if(this.props.control)
	    	{
				let result;
				if(this.props.column.isdynamic == true)
				{
					result = this.props.control.doFieldModifiedRemote(this.props.column.dynamicFieldName,_val,this.props.value,null,null,{dynamicColumn:true,dynamicKey:this.props.column.dynamicFieldLabel});
				}
				else
				{
					let _oldValue = this.props.value;
					result = this.props.control.doFieldModifiedRemote(this.props.column.key,_val,_oldValue);
					let _newValue;
					if(this.excelEditor){
						//TODO_YL  修改 modifiedfied 修改本身字段 不生效 
						_newValue = $(this.getInputNode()).text();
						if(this.props.rowData[this.props.dataField] !=_oldValue && this.props.rowData[this.props.dataField]!=_newValue){
							_newValue = this.props.rowData[this.props.dataField];
						}
					}
					else{
						_newValue = this.getInputNode().value;
					}

					
					if(text != _newValue)
						updated[this.props.column.key] = _newValue;
					
				}
	    		if(!result)// && !this.props.control.isDataMethodField)
	    		{
	    			return {};
	    		}
	    	}
		}
		if(this.props.stringSize && this.props.stringSize>0 && this.props.stringSize < updated[this.props.column.key].length){
			Warn.show({text:'所输入内容超出字段设定长度 '+this.props.stringSize +" 请重新输入！！" });
			return {};
		}
	    return updated;
	}


	//当有下拉框存在的时候 项目编辑器在失去焦点时不销毁
	//zsg 由于按Tab键导航会导致重复提交问题（同时出发pressTab和blur） 所以通过一个justCommit属性来判断是否刚刚提交过
	//下拉框是否销毁由项目编辑器决定
	handleBlurCommit()
	{
		if(this.justCommit == true)
		{
			this.justCommit = false;return false;
		}
			
	   if(this.lookupStates.isShowed)
	   	return false;
	   return true;
	}

	buttonDownClick(e)
	{
		return super.buttonDownClick(e);


		let droped = super.buttonDownClick();
		if(droped)
		{
			LookupActions.renderCmp(this.props.gridId);
		}
		return droped;
		
	}

	componentDidMount()
	{
		
		if(this.props.control)
		{
			var _allowEdit = this.props.control.getProperty_AllowEdit_Final(this.props.rowData);

			/*if(this.props.hasInitialValue == true && _allowEdit == false && this.props.dataField && this.props.rowData)
			{
				let _value = this.props.rowData[this.props.dataField];
				$(this.inputField).val(_value);
			}*/

			this.doSetEnable(_allowEdit);
		}
		
		
		let copy = Object.assign({},this.props.contextMenuData);
		if(copy.items)
		{
			for(let i = 0;i<copy.items.length;i++)
			{
				let item = copy.items[i];
				if(item && item.label == "过滤[Ctrl+T]")
				{
					item.action = this.queryFilter.bind(this);
					break;
				}
			}
			$(this.inputField).contextPopup(copy);
		}
		else
		{
			$(this.inputField).contextPopup(this.props.contextMenuData);
		}
		if(this.excelEditor == true)
		{
			try 
			{
				if (window.getSelection) {
					var range = window.getSelection(); // 创建range
					range.selectAllChildren(this.inputField); // range 选择obj下所有子内容
					range.collapseToEnd(); // 光标移至最后
				}
			} 
			catch (e) 
			{
			}
		}
		this.initToolTip();
	}

	checkDropDownHas()
	{
		super.checkDropDownHas();

		if(this.state.dropDownNumKeyBoard)
		{
			var nowAllowEdit = $(this.inputField).attr("readonly")==undefined;
			if(nowAllowEdit)
				$(this.downArrowButton).show();
		}
			
	}

	queryFilter()
	{
		if(!this.props.group)
			return;
		var _dataField = this.props.dataField;
		if(_dataField && this.props.rowData && this.props.rowData.hasOwnProperty(_dataField))
		{
			
			var value = this.props.rowData[_dataField];
			this.props.group.queryFilter(_dataField,value);
		}
	}

	buildExtralWhereItem(lookup)
	{
		if(this.props.groupAlias!="" && typeof(lookup.setExtralWhereItemValueForRefresh) == "function")
		{
			var filterField = this.props.filterField;
			if(filterField)
			{
				var alias = this.props.groupAlias;
				filterField = StringUtil.convertToFirstLowerCase(filterField);
				var _record = this.props.rowData;
				var _key = alias+"."+filterField;
				let spit = this.props.dataField.split(".")
				if(spit.length == 3){
					_key = alias+"."+spit[1]+"."+filterField;
				}
				var filterfieldvalue = (_record&&_record.hasOwnProperty(_key))?_record[_key]:null;//this.record[alias+"."+filterField];
				//TODO YL 修改 
				if(filterfieldvalue == undefined || filterfieldvalue == null ){
					filterfieldvalue = _record[alias+"."+filterField]
				}
				if(filterfieldvalue && filterfieldvalue != "")
				{
					lookup.setExtralWhereItemValueForRefresh(false,filterfieldvalue);
				}
				else
				{
					// lookup.setExtralWhereItemValueForRefresh(false,"#NULL_FILTER_FIELD#");
					lookup.setExtralWhereItemValueForRefresh(false,"");
				}
			}
		}
	}

	doSetEnable(enable)
	{
		var nowAllowEdit = $(this.inputField).attr("readonly")==undefined;
		if(nowAllowEdit == true && enable == false)
		{
			$(this.downArrowButton).hide();//css("display","none");
			$(this.inputField).css("backgroundColor",FormItemConst.EDITOR_NOTEDIT_COLOR);
			$(this.inputField).attr("readonly","readonly");
			if(this.excelEditor == true)
			{
				this.excelEditorAllowEdit = false;
				$(this.inputField).attr("contenteditable","false");

				/*if(!this.props.value)
				{
					//$(this.inputField).css("height","33px");
					//alert(this.inputField.style.getPropertyValue("height"));
					//$(this.inputField).removeClass("stringEditorExcel").removeClass("stringEditorExcel2").addClass("stringEditorExcel3");
				}*/
				
			}
			else
			{
				this.setState({excelEditor:true});
			}
		}
		else if(nowAllowEdit == false && enable == true)
		{
			if(this.hasLookup)
				$(this.downArrowButton).show();//css("display","block");
			$(this.inputField).css("backgroundColor","#FFFFFF");
			$(this.inputField).removeAttr("readonly");
			if(this.excelEditor == true)
			{
				$(this.inputField).attr("contenteditable","true");
				this.excelEditorAllowEdit = true;
			}
		}
	}

	showDropDown()
	{
		var nowAllowEdit = $(this.inputField).attr("readonly")==undefined;
		if(!nowAllowEdit)return;
		super.showDropDown();
	}

	onKeyDownHandler2(e)
	{
		
		if(13===e.keyCode)
		{
			e.stopPropagation();
			return;
		}
			
		super.onKeyDownHandler(e);
	}

	getInputNode() 
	{
		if(this.isMutiRow())
		{
		    let domNode = ReactDOM.findDOMNode(this);
		    if (domNode.tagName === 'TEXTAREA') {
		      return domNode;
		    }

		    return domNode.querySelector('textarea:not([type=hidden])');	
		}
		else
		{
			let domNode = ReactDOM.findDOMNode(this);
		    if (domNode.tagName === 'INPUT' || domNode.tagName === 'TEXTAREA') {
		      return domNode;
		    }

			return domNode.querySelector('input:not([type=hidden])') 
						|| domNode.querySelector('textarea:not([type=hidden])')
						|| domNode.querySelector('div.stringEditorExcel')
						|| domNode.querySelector('div.stringEditorExcel2');	
		}
	    
  	}

  	isMutiRow()
  	{
  		let displayHeight=this.state.displayHeight;
		return displayHeight>1;
  	}

	isLastColumn()
	{
		let arg = {key:this.props.column.key,gridId:this.props.gridXml.id,last:false};
		UtilActions.getDataGridColumnInfo(arg);
		return arg.last;
	}

	onKeyDownHandler2(e)
	{
		if(this.excelEditorAllowEdit == false)
		{
			e.preventDefault();
			//e.stopPropagation();
			return;
		}
		if(9===e.keyCode)
		{
			e.preventDefault();
			return true;
		}

		if(13==e.keyCode)
		{
			/*TODO 这段不知道为什么加上了 暂时先去掉let formId = this.props.formId;
			let gridId = this.props.gridXml.id;
			FocusActions.focusSet(formId,gridId,false);*/
			return true;
		}
		//禁用ctrl+A
		if(e.ctrlKey && e.keyCode == 65)
		{
			e.stopPropagation();
			return true;
		}
		super.onKeyDownHandler(e);
	}

	
	
	render()
	{
		
		let rowStyles = this.getRowStyles();
		let _style = {padding:'2px',paddingRight:'13px',backgroundColor:'#ffffff',fontSize:"12px",cursor:'text'};
		let _textAlign = this.props.control.getProperty_Alignment();_style.textAlign = _textAlign.toLowerCase();
		if(rowStyles)
		{
			for(let i = 0;i<rowStyles.length;i++)
			{
				let rowStyle = rowStyles[i];
				let bool = this.props.group.analysisConditionSingleRecord1(this.props.rowData,rowStyle.recordCondition);
				if(bool)
				{
					if(rowStyle.color != -1)
						_style.color = "#"+rowStyle.color.toString(16);//原来是break 说明多个条件之间是或 现在改成了无条件覆盖
					if(rowStyle.fontSize != -1)
						_style.fontSize = rowStyle.fontSize;
					if(rowStyle.fontFamily != null)
						_style.fontFamily = rowStyle.fontFamily;
					if(rowStyle.fontWeight != null)
						_style.fontWeight = rowStyle.fontWeight;
				}
			}
		}


		let colStyles = this.getEditorStyles();
		if(colStyles)
		{
			for(let i = 0;i<colStyles.length;i++)
			{
				let colStyle = colStyles[i];
				let bool = this.props.group.analysisConditionSingleRecord1(this.props.rowData,colStyle.recordCondition);
				if(bool)
				{
					if(colStyle.color != -1)
						_style.color = "#"+colStyle.color.toString(16);//原来是break 说明多个条件之间是或 现在改成了无条件覆盖
					if(colStyle.fontSize != -1)
						_style.fontSize = colStyle.fontSize;
					if(colStyle.fontFamily != null)
						_style.fontFamily = colStyle.fontFamily;
					if(colStyle.fontWeight != null)
						_style.fontWeight = colStyle.fontWeight;
				}
			}
		}

		
		let dropDownButton = null;
		this.checkDropDownHas();
		let _display = this.hasLookup?"block":"none";
		this.excelEditor = false;
		if(this.state.dropDownNumKeyBoard)
		{
			if(this.state.allowEdit)
				dropDownButton = <i ref={node => this.downArrowButton = node} onMouseDown={this.showNumKeyBoard.bind(this)} className="fa fa-keyboard-o"  
					style={{display:_display,position:'absolute',top:'calc(100% / 2 - 7px)',left:'calc(100% - 11px)',fontSize:'11px',cursor:'pointer',zIndex:3}}></i>;
		}
		else
		{
			dropDownButton = <i ref={node => this.downArrowButton = node} className="fa fa-sort-desc" onMouseDown={this.buttonDownClick.bind(this)} style={{display:_display,position:'absolute',top:'calc(100% / 2 - 7px)',left:'calc(100% - 11px)',fontSize:'11px',cursor:'pointer',zIndex:3}}></i>;
		}

		if(this.isMutiRow())
		{
			return(
			    <div className="input-group" ref={node=>this.inputgroup=node} style={{width:'100%'}}>
			        <textarea spellCheck="false" ref={node => this.inputField = node} className="form-control" style={_style} defaultValue={this.props.value} onKeyDown={this.onKeyDownHandler2.bind(this)}/>
			        {dropDownButton}
			    </div>
			);
		}
		if(_display == "none" || this.state.excelEditor == true)
		{
			//_style.height = "auto";
			this.excelEditor = true;_style.paddingRight = "2px";
			let _minWidth = Math.max(this.props.column.width,20);
			_style.minWidth  = _minWidth+"px";
			_style.minHeight = this.props.height+"px";
			/*_style.maxWidth = "300px";
			if(this.props.value)
			{
				let length = this.props.value.visualLength(_style.fontSize);
				let _columnWidth = this.props.column.width;
				if(length>(_columnWidth-25))
				{
					_style.width = (length+25)+"px";
				}
			}*/
			let _className = "form-control stringEditorExcel";
			let isLastColumn = this.isLastColumn();
			if(isLastColumn)
				_className = "form-control stringEditorExcel2";
			let _contentEditable = "true";
			if(this.state.excelEditor == true)
			{
				_style.backgroundColor = FormItemConst.EDITOR_NOTEDIT_COLOR;_contentEditable = "false";
			}

			//TODO_Yl 如果存在换行 需要换行
			_style.whiteSpace = "pre-wrap";
			let _v = this.props.value;

			/*if(this.props.hasInitialValue == true && this.props.control)
			{
				var _allowEdit = this.props.control.getProperty_AllowEdit_Final();

				if(_allowEdit == false)
				{
					if(this.props.dataField && this.props.rowData)
					{
						let _value = this.props.rowData[this.props.dataField];
						_v = _value;
					}
				}
				else
				{
					_v = null;
				}
			}*/
			return(
				<div className="input-group" ref={node=>this.inputgroup=node} style={{width:"100%"}}>
					<div contentEditable={_contentEditable} spellCheck="false" ref={node => this.inputField = node} 
						type="text" className={_className} style={_style} defaultValue={_v} onKeyDown={this.onKeyDownHandler.bind(this)}>
						{_v}
					</div>
					{dropDownButton}
				</div>
			);
		}
		else
		{
			if(this.props.height){
				_style.maxHeight=this.props.height-2;
			}
			return(
				<div className="input-group" ref={node=>this.inputgroup=node} style={{width:'100%'}}>
					<input spellCheck="false" ref={node => this.inputField = node} type="text" className="form-control" style={_style} defaultValue={this.props.value} onChange={this.textOnChange.bind(this)} onKeyDown={this.onKeyDownHandler.bind(this)}/>
					{dropDownButton}
				</div>
			);
		}
		//<span ref={node => this.downArrowButton = node} className="input-group-addon" style={{cursor:'pointer',paddingTop:'0px',paddingBottom:'3px',paddingLeft:'6px',paddingRight:'6px'}} onMouseDown={this.buttonDownClick.bind(this)}><i className="fa fa-sort-desc"></i></span>
			
	}
}




// WEBPACK FOOTER //
// ./src/formItem/FormItemStringEditorForDataGrid.js